import { vec4 } from 'gl-matrix';

import { Vector3 } from '@canvas/vector';

import {
  n300,
  n400,
  skeletonDarkDefault,
  skeletonDarkLightest,
  skeletonDefault,
  skeletonLightest,
  skeletonShimmerDark,
  skeletonShimmerLight,
} from './colors';

export type FallbackLineColorName = keyof typeof fallbackLineColors;

export const fallbackLineColors = {
  n300: vec4.fromValues(n300.x, n300.y, n300.z, 255),
  n400: vec4.fromValues(n400.x, n400.y, n400.z, 255),
  skeletonOpaque: vec4.fromValues(
    skeletonLightest.x,
    skeletonLightest.y,
    skeletonLightest.z,
    skeletonLightest.w
  ),
  skeleton: vec4.fromValues(
    skeletonDefault.x,
    skeletonDefault.y,
    skeletonDefault.z,
    skeletonDefault.w
  ),
  skeletonShimmer: vec4.fromValues(
    skeletonShimmerLight.x,
    skeletonShimmerLight.y,
    skeletonShimmerLight.z,
    skeletonShimmerLight.w
  ),
};

// Text skeleton colors
const n300Dark = new Vector3(34, 39, 43);
const n400Dark = new Vector3(29, 33, 37);

export const fallbackLineColorsDark: typeof fallbackLineColors = {
  n300: vec4.fromValues(n300Dark.x, n300Dark.y, n300Dark.z, 255),
  n400: vec4.fromValues(n400Dark.x, n400Dark.y, n400Dark.z, 255),
  skeletonOpaque: vec4.fromValues(
    skeletonDarkLightest.x,
    skeletonDarkLightest.y,
    skeletonDarkLightest.z,
    skeletonDarkLightest.w
  ),
  skeleton: vec4.fromValues(
    skeletonDarkDefault.x,
    skeletonDarkDefault.y,
    skeletonDarkDefault.z,
    skeletonDarkDefault.w
  ),
  skeletonShimmer: vec4.fromValues(
    skeletonShimmerDark.x,
    skeletonShimmerDark.y,
    skeletonShimmerDark.z,
    skeletonShimmerDark.w
  ),
};
